import React from "react";

import i18next from "i18next";

import { SkuIcon } from "svg";

import { Badge, IconWrapper, Nav, StyledNavLink } from "./styles";

type Props = {
  // @todo fix types
  countOfMissingSkuMappings: any;
  isVisible: boolean;
};

const SkuNavItem = ({ countOfMissingSkuMappings, isVisible }: Props) => {
  if (!isVisible) {
    return null;
  }

  return (
    <Nav.Item>
      <Badge>
        {countOfMissingSkuMappings === undefined &&
        !countOfMissingSkuMappings?.length ? (
          <div className="loader" />
        ) : (
          <Badge
            style={{
              backgroundColor: "#1976d2",
              padding: "3px",
            }}
          >
            {countOfMissingSkuMappings}
          </Badge>
        )}
      </Badge>
      <StyledNavLink to="/create-sku-mapping">
        <IconWrapper>
          <SkuIcon />
        </IconWrapper>
        {i18next.t("sku")}
      </StyledNavLink>
    </Nav.Item>
  );
};

export default SkuNavItem;
